import React from 'react';
import { FormattedMessage } from 'react-intl';

type TVitalItemHeaderProps = {
  icon: React.ReactNode;
  title: string;
};

const VitalItemHeader: React.FC<TVitalItemHeaderProps> = ({
  icon,
  title,
}: TVitalItemHeaderProps) => {
  return (
    <div className="vi-header">
      <div className="vi-header-icon">{icon}</div>
      <h6>
        <FormattedMessage id={title} />
      </h6>
      {/* <img
        className="vi-header-action"
        onClick={onAdd}
        src={require('../../../../assets/svg/circle-plus.svg').default}
        alt=""
      /> */}
    </div>
  );
};

export default VitalItemHeader;
